import routeName from '../constant';

const routes = [
    {
        path: 'policy-apply',
        name: routeName.POLICY_APPLY,
        component: () => import('@/views/aplCatl640and631/B3/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '保險單補發', leaveAlert: true, code: 'B3', unableBack: true },
    }];

export default routes;
